import Filter from "./Filter";
import _ from "lodash";

export default class FilterList {
  filters;

  constructor(columns, groups, columnIdToValuesLowerCase) {
    var productLists = groups.map(group => group.products);
    var products = _.union(...productLists);
    this.filters = columns
      .map(column => new Filter(column, products, columnIdToValuesLowerCase))
      .filter(filter => filter.values.length > 0);
  }
}
